export default "__VITE_ASSET__0XSR6ZGB__"